<template lang="pug">
  .the-breadcrumbs(v-if="shouldShowBreadcrumbsArea")
    .inner
      ol.breadcrumbs(v-if="breadcrumbs.length > 0")
        li(v-for="breadcrumb in breadcrumbs")
          a(:href="breadcrumb.path" @click="$_gaSendEvent(`${breadcrumb.name}へ遷移`, 'パンくず', breadcrumb.name)") {{ breadcrumb.name }}
      .skeleton-wrapper(v-else)
        .skeleton-text
</template>

<script>
  import { mapGetters } from 'vuex'
  import GlobalMixin from '../../../mixin/GlobalMixin'

  export default {
    name: 'TheBreadcrumbs',
    mixins: [GlobalMixin],
    computed: {
      ...mapGetters([
        'breadcrumbs'
      ]),
      shouldShowBreadcrumbsArea() {
        // トップページの場合は表示しない
        if (this.$route.path === '/') {
          return false
        }
        return true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../assets/stylesheets/v1/styles";

  .the-breadcrumbs {
    @include margin-bottom(xs);

    > .inner {
      width: 100%;
      max-width: 1300px;
      margin: 0 auto;
      @include padding(zero, xs);

      > .breadcrumbs {
        > li {
          display: inline;

          &:after {
            content: '>';
            color: $gray-400;
            @include padding(zero, xxxs);
          }
          &:last-child:after {
            content: '';
          }

          > a {
            font-family: $font-family-sans;
            font-weight: $font-weight-regular;
            font-style: $font-style-not-italic;
            @include font-size(xxs);
            line-height: $line-height-none;
            color: $black-400;
            text-decoration: none;
            cursor: pointer;
            &:hover {
              color: $olive-300;
            }
          }
        }
      }
      .skeleton-wrapper {
        display: flex;
        align-items: center;
        height: 100%;

        .skeleton-text {
          height: 16px;
          width: 200px;
        }
      }
    }
  }
</style>
